import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-feature-highlight',
  templateUrl: './feature-highlight.component.html',
  styleUrls: ['./feature-highlight.component.scss'],
})
export class FeatureHighlightComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() videoUrl: string | undefined;
  @Input() icon: string = 'sparkles-outline';

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer
  ) {}

  /** YouTube watch or youtu.be URL → embed URL for iframe. Other URLs returned as-is for <video>. */
  get safeVideoUrl(): SafeResourceUrl | null {
    if (!this.videoUrl?.trim()) return null;
    const url = this.videoUrl.trim();
    const embed = this.toYouTubeEmbedUrl(url);
    if (embed) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  get isYouTube(): boolean {
    return !!this.videoUrl && /youtube\.com|youtu\.be/i.test(this.videoUrl.trim());
  }

  private toYouTubeEmbedUrl(url: string): string | null {
    const trim = url.trim();
    const m = trim.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (m) {
      return `https://www.youtube.com/embed/${m[1]}`;
    }
    if (/youtube\.com\/embed\//i.test(trim)) return trim;
    return null;
  }

  dismiss() {
    this.modalCtrl.dismiss({ seen: true });
  }
}
